import { render } from "./BdAccountManagement.vue?vue&type=template&id=d2680d30&scoped=true"
import script from "./BdAccountManagement.vue?vue&type=script&lang=js"
export * from "./BdAccountManagement.vue?vue&type=script&lang=js"

import "./BdAccountManagement.vue?vue&type=style&index=0&id=d2680d30&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2680d30"]])

export default __exports__